<template>
    <div class="custome-select">
        <p v-if="title" style="margin: 10px">
            {{ title }}
        </p>
        <el-select
            ref="CustomSelectRef"
            v-model="optionValue"
            v-bind="$attrs"
            :placeholder="optionValue?.toString().length ? '' : placeholder"
            collapse-tags
            collapse-tags-tooltip
            :filterable="filterable"
            :teleported="teleported"
            :clearable="clearable"
            placement="bottom"
            @change="handleChange"
            @remove-tag="handleRemoveSingleTag"
            @clear="handleDelete"
        >
            <el-option
                v-for="item in formatOptions"
                :key="item.value"
                :disabled="item.disabled"
                :label="needTranslate ? $t(item.label) : item.label"
                :value="useObject ? item : item.value"
            />
        </el-select>
        <slot name="remind"></slot>
    </div>
</template>

<script lang="ts" setup>
import {ref, computed, type PropType} from 'vue';
const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    options: {
        type: Array as PropType<any[]>,
        default: () => []
    },
    modelValue: {
        type: [String, Number, Array<any>, Object],
        default: ''
    },
    value: {
        type: String,
        default: 'value'
    },
    label: {
        type: String,
        default: 'label'
    },
    labels: {
        type: String,
        default: ''
    },
    placeholder: {
        type: String,
        default: ''
    },
    clearable: {
        type: Boolean,
        default: true
    },
    filterable: {
        type: Boolean,
        default: true
    },
    needTranslate: {
        type: Boolean,
        default: false
    },
    teleported: {
        type: Boolean,
        default: false
    },
    useObject: {
        type: Boolean,
        default: false
    }
});

const emits = defineEmits(['update:modelValue', 'update:labels', 'change', 'removeTag', 'clear']);
const optionValue = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits('update:modelValue', val);
        emitLabels(val);
    }
});
const CustomSelectRef = ref<any>();
const emitLabels = (values: any) => {
    const arr: string[] = [];
    formatOptions.value.forEach((item) => {
        if (values.toString().includes(item.value)) {
            arr.push(item.label);
        }
    });
    emits('update:labels', arr.join(','));
};

const formatOptions = computed(() => {
    const {options, value, label} = props;
    return options.map((o) => {
        return {
            ...o,
            value: o[value],
            label: o[label]
        };
    });
});

const handleChange = (values: number | string | any) => {
    const res = values + '';
    const labels: string[] = [];
    formatOptions.value.forEach((item) => {
        if (res.includes(item.value)) {
            labels.push(item.label);
        }
    });
    emits('change', {values, labels});
};

const handleRemoveSingleTag = (values: number | string | any) => {
    emits('removeTag', values);
};

const handleDelete = (values: number | string | any) => {
    emits('clear', values);
};
const handleFocus = () => {
    CustomSelectRef.value?.focus();
}
const handleBlur = () => {
    CustomSelectRef.value?.blur();
}
defineExpose({ handleFocus, handleBlur });
</script>
<style lang="scss">
.custome-select {
    .el-select__tags {
        max-width: 200px !important;
    }
    .el-select__input {
        padding-right: 5px;
    }
}
</style>
<style lang="scss" scoped></style>
